import React, { useEffect, useState } from 'react'
import LikeIcon from '../../assets/images/icon_like.png'
import LikeActiveIcon from '../../assets/images/icon_like_active.png'
import UnlikeIcon from '../../assets/images/icon_unlike.png'
import UnlikeActiveIcon from '../../assets/images/icon_unlike_active.png'
import CommentIcon from '../../assets/images/icon_comment_normal.png'
import CommentActiveIcon from '../../assets/images/icon_comment.png'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { feedbackQueries, modulesQueries } from '../../graphql/queries'
import { feedbackMutations } from '../../graphql/mutations'
import CommentModal from './CommentModal'
import ResearchModal from './ResearchModal'

const useStyles = makeStyles(theme => ({
    feedbackButtons: {
        minWidth: 'unset',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },

    cursorChange: {
        '&:hover': {
            cursor: 'pointer'
        }
    }

})
)

const FeedbackButtonsBox = styled.button`
    border: none;
    background-color: transparent;
    :focus {
        outline: none!important;
    }
`

const RateIcon = styled.img`
    max-height: 28px;

    @media(max-width: 1050px) {
    max-height: 24px;
    }
`

const FeedbackButtons = ({ conteudoId, cursoId, trilhaId }) => {
    const classes = useStyles()
    const [errorComment, setErrorComment] = useState('')
    const [feedbackType, setFeedbackType] = useState('')
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [modalResearch, setModalResearch] = useState(true)
    const [readyToShow, setReadyToShow] = useState(false)

    const { data: modulo } = useQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

    const currentModule = modulo?.modulo.find(module => {
        const currentCourse = module.cursos?.find(cur => cur === cursoId)
        return currentCourse
    })

    const moduloId = currentModule?._id

    const { data: moduleResearches, refetch: refetchModuleResearches } = useQuery(feedbackQueries.GET_MODULE_EVALUATION, {
        variables: { modulo_id: moduloId || '' }
    })

    const { data: evaluationData, refetch: refetchEvaluation } = useQuery(feedbackQueries.GET_EVALUATION, {
        variables: { conteudo_id: conteudoId || '' }
    })

    const [adicionarAvaliacao ] = useMutation(feedbackMutations.ADD_VALUATION, {
    })

    const avaliacoesCurso = moduleResearches?.avaliacaoCurso || []

    const atualAvaliacaoCurso = avaliacoesCurso.find(avaliacao => {
        const avaliacaoConteudo = avaliacao.conteudo_id
        const avaliacaoTrilha = avaliacao.trilha_id
        const avaliacaoCurso = avaliacao.curso_id

        if (avaliacaoConteudo === conteudoId && avaliacaoTrilha === trilhaId && avaliacaoCurso === cursoId) {
            return avaliacao
        } else {
            return false
        }
    })

    const { data: commentData, refetch: refetchComment } = useQuery(feedbackQueries.GET_COMMENT, {
        variables: { conteudo_id: conteudoId || '' }
    })

    const currentFeedbackType = () => {
        const type = evaluationData?.avaliacao?.tipo
        if (type === 'like')
            setFeedbackType('like')
        else if (type === 'dislike')
            setFeedbackType('dislike')
        else
            setFeedbackType('')
    }

    const handleLike = () => {
        adicionarAvaliacao({
            variables: {
                tipo: "like",
                modulo_id: moduloId || "",
                curso_id: cursoId || "",
                conteudo_id: conteudoId || "",
                trilha_id: trilhaId || "",
            }
        })
    }

    const handleDislike = () => {
        adicionarAvaliacao({
            variables: {
                tipo: "dislike",
                modulo_id: moduloId || "",
                curso_id: cursoId || "",
                conteudo_id: conteudoId || "",
                trilha_id: trilhaId || "",
            }
        })
    }

    const quantComment = commentData?.comentariosAvaliacao.length
    const lastComment = commentData?.comentariosAvaliacao[quantComment - 1]?.descricao
    const [comment, setComment] = useState(lastComment || null)

    const changeComment = e => {
        setComment(e.target.value)
        if (!e.target.value) {
            setErrorComment('Escreva o seu comentário.')
        } else {
            setErrorComment('')
        }
    }

    const handleClose = () => {
        setModalIsOpen(false)
    }

    const handleOpen = () => {
        setModalIsOpen(true)
    }

    useEffect(() => {
        refetchEvaluation()
        currentFeedbackType()
        refetchModuleResearches()
    })

    useEffect(() => {
        if (moduloId && cursoId && conteudoId && trilhaId) setReadyToShow(true)
        refetchComment()
        setComment(lastComment)
    }, [moduloId, cursoId, conteudoId, trilhaId, lastComment]) // eslint-disable-line


    return (
        <>
            <FeedbackButtonsBox
                className={classes.feedbackButtons}
                onClick={() => handleLike()}
                disabled={!readyToShow}
            >
                {(feedbackType === 'like') ? <div className={classes.cursorChange}><RateIcon src={LikeActiveIcon}/></div> : <div className={classes.cursorChange}><RateIcon src={LikeIcon} /></div>}
            </FeedbackButtonsBox>
            <FeedbackButtonsBox
                className={classes.feedbackButtons}
                onClick={() => handleDislike()}
                disabled={!readyToShow}
            >
                {(feedbackType === 'dislike') ? <div className={classes.cursorChange}><RateIcon src={UnlikeActiveIcon} /></div> : <div className={classes.cursorChange}><RateIcon src={UnlikeIcon} /></div>}
            </FeedbackButtonsBox>
            <FeedbackButtonsBox
                className={classes.feedbackButtons}
                style={{ marginRight: '2em' }}
                onClick={() => handleOpen()}
                disabled={!readyToShow}
            >
                {!comment ? <div className={classes.cursorChange}><RateIcon src={CommentIcon} /></div> : <div className={classes.cursorChange}><RateIcon src={CommentActiveIcon} /></div>}
            </FeedbackButtonsBox>
            <CommentModal
                isOpen={modalIsOpen}
                commentData={commentData}
                refetchComment={refetchComment}
                changeComment={changeComment}
                comment={comment}
                lastComment={lastComment}
                setComment={setComment}
                errorComment={errorComment}
                onClose={handleClose}
                moduloId={moduloId || ''}
                cursoId={cursoId || ''}
                conteudoId={conteudoId || ''}
                trilhaId={trilhaId || ''}

            />
            {((atualAvaliacaoCurso || {}).perguntas || {}).length && (
                <ResearchModal
                    isOpen={modalResearch}
                    onClose={() => setModalResearch(!modalResearch)}
                    moduloId={moduloId || ''}
                    cursoId={cursoId || ''}
                    conteudoId={conteudoId || ''}
                    trilhaId={trilhaId || ''}
                    perguntas={(atualAvaliacaoCurso || {}).perguntas}
                    pesquisaId={(atualAvaliacaoCurso || {})._id}
                />
            )}
        </>
    )
}

export default FeedbackButtons